import React from 'react';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui';
import { useSuggestions, useRefreshSuggestions } from '@/hooks/useSuggestionsQuery';
import SuggestionRow from './components/SuggestionRow';

const Discover: React.FC = () => {
  const { data, isLoading } = useSuggestions();
  const refreshSuggestions = useRefreshSuggestions();

  const scenes = data?.scenes ?? [];
  const library = data?.library ?? [];
  const serendipity = data?.serendipity ?? [];
  const isEmpty = !isLoading && scenes.length === 0 && library.length === 0 && serendipity.length === 0;

  const handleRefresh = () => {
    refreshSuggestions.mutate(undefined, {
      onError: (error) => console.error('Failed to refresh suggestions', error),
    });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <Compass className="w-7 h-7 text-meradio-primary" />
          <h1 className="text-3xl font-bold text-meradio-dark dark:text-text-dark-primary">Discover</h1>
        </div>
        {!isEmpty && (
          <Button
            onClick={handleRefresh}
            disabled={refreshSuggestions.isPending}
            isLoading={refreshSuggestions.isPending}
            variant="outline"
          >
            {refreshSuggestions.isPending ? 'Refreshing...' : 'Refresh'}
          </Button>
        )}
      </div>

      {isLoading ? (
        <div className="flex gap-4 overflow-x-auto pb-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="w-56 h-48 flex-shrink-0 rounded-xl bg-neutral-200 dark:bg-bg-dark-secondary animate-pulse"
            />
          ))}
        </div>
      ) : isEmpty ? (
        <div className="text-center py-16">
          <Compass className="w-16 h-16 text-neutral-300 dark:text-text-dark-tertiary mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-neutral-600 dark:text-text-dark-primary mb-2">
            No suggestions yet
          </h3>
          <p className="text-neutral-500 dark:text-text-dark-secondary mb-6">
            Follow a few channels and like some videos, then refresh to see personalized picks.
          </p>
          <Button
            onClick={handleRefresh}
            disabled={refreshSuggestions.isPending}
            isLoading={refreshSuggestions.isPending}
            variant="primary"
          >
            {refreshSuggestions.isPending ? 'Refreshing...' : 'Refresh'}
          </Button>
        </div>
      ) : (
        <>
          <SuggestionRow title="From scenes you follow" suggestions={scenes} />
          <SuggestionRow title="Behind your likes" suggestions={library} />
          <SuggestionRow title="Something different" suggestions={serendipity} />
        </>
      )}
    </div>
  );
};

export default Discover;
